import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { NsEmpWebExpData } from "../../models/emp-web-exp.model";
import { EmpUserService } from "../../services/emp-user.service";
@Injectable({
  providedIn: "root"
})
export class MealService {
  constructor(private http: HttpClient, private user: EmpUserService) {}
  private selectedMealItem$ = new BehaviorSubject<NsEmpWebExpData.IMeal>(null);
  selectedMealItem = this.selectedMealItem$.asObservable();

  private mealData$ = new ReplaySubject<NsEmpWebExpData.IMeal[]>(1);
  mealData = this.mealData$.asObservable();

  private mealChange$ = new Subject<NsEmpWebExpData.IMeal[]>();
  mealChange = this.mealChange$.asObservable();

  private guidChange$ = new BehaviorSubject<string>("");
  guidChange = this.guidChange$.asObservable().pipe(distinctUntilChanged());

  public bookingRes = new BehaviorSubject<NsEmpWebExpData.IMeal[]>([]);

  private changeRes$ = new Subject<NsEmpWebExpData.IMeal[]>();
  changeRes = this.changeRes$.asObservable();

  private startEndShift = new BehaviorSubject<NsEmpWebExpData.IMealCutOff>(null);
  startEndTime = this.startEndShift.asObservable();
  changedGuid(data: string) {
    this.guidChange$.next(data);
  }
  getMealData(data, startTime, endTime, floorId?) {
    let params = floorId && new HttpParams().set("floorPremiseId", floorId);
    return this.http.get<NsEmpWebExpData.IMeal[]>(
      this.user.environment.empExp + "/meal-plan/" + `${this.user.employeeInfo.buid}/${data}?endTime=${endTime}&startTime=${startTime}`,
      { params }
    );
  }
  setMealData(data: NsEmpWebExpData.IMeal[]) {
    this.mealChange$.next(data);
  }
  changedMealData(data: NsEmpWebExpData.IMeal[]) {
    this.changeRes$.next(data);
  }
  bookingResponse(data: NsEmpWebExpData.IMeal[]) {
    this.bookingRes.next(data);
  }
  selectedItemResponse(data: NsEmpWebExpData.IMeal) {
    this.selectedMealItem$.next(data);
  }
  mealDataSetter(data: NsEmpWebExpData.IMeal[]) {
    this.mealData$.next(data);
  }
  startEndShiftData(start: number, end: number, timeZone: string, floorId?: string) {
    const data = {
      startShift: start,
      endShift: end,
      timeZone: timeZone,
      floorId: floorId
    };
    this.startEndShift.next(data);
  }
}
